import { usePaymentFlags } from '@/feature/devsettings/hooks/use-payment-flags-store';
import { useJurisdictionStore } from '@/hooks/use-jurisdiction';

/**
 * Custom hook that provides visibility controls for payment method UI elements.
 * Determines which payment methods and options should be displayed to users.
 *
 * @returns {Object} Object containing visibility control flags
 * @returns {boolean} showDepositIbt - True if IBT should be shown (not hidden by hide_deposit_ibt flag)
 * @returns {boolean} showPayByBankWeb - True if Pay By Bank should be shown on web
 */
export const usePaymentVisibility = () => {
    const { flags } = usePaymentFlags();
    const jurisdictionSettings = useJurisdictionStore(state => state.jurisdictionSettings);

    const isDebugMode = flags.isDebugMode.enabled;

    // Control visibility of Instant Bank Transfer (IBT) option
    // Reference: https://github.com/betrapp/pickem/pull/2454
    // Note: This flag is primarily used for the web version of the app
    // For web: hide IBT if hide_deposit_ibt is enabled, regardless of enable_nuvei
    // For mobile: this flag is not typically used, as IBT visibility is controlled differently
    const showDepositIbt = isDebugMode
        ? flags.showDepositIbt.enabled
        : !jurisdictionSettings?.globalSettings?.featureFlags?.hide_deposit_ibt?.enabled;

    // Control visibility of Pay By Bank (Paysafe) option for web, it includes saved payment methods
    const showPayByBankWeb = !(
        jurisdictionSettings?.globalSettings?.featureFlags?.hide_pay_by_bank_web?.enabled ?? true
    );

    return {
        showDepositIbt,
        showPayByBankWeb,
    };
};
